import React from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import './tittleFAQ.css';

const QuestionFAQ = (props) => {
    const [styleState, setStyleState] = useState({
        onOfmenu: 'dashboard__btn-chevron rotate-180',
        onOfopacity: 'dashboard__submenu',
        onOfmenu2: 'dashboard__btn-chevron ',
        onOfopacity2: 'dashboard__submenu max-height-0 opacity-0',
    });
    const [isExpand, setIsEcpand] = useState(false);
    function onClick() {
        setIsEcpand(!isExpand);
        props.setIsEcpand(!isExpand);
    }

    return (
        <>
            <div className="tittleFAQ_headerQuestion">
                <svg
                    onClick={onClick}
                    className={props.isExpand ? styleState.onOfmenu : styleState.onOfmenu2}
                    viewBox="0 0 24 24"
                    width="24px"
                    height="24px"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6 9L12 15L18 9"
                        strokeWidth="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    ></path>
                </svg>
                <p className={props.isRed ? 'isRed' : ''}>{props.children}</p>
            </div>
        </>
    );
};

export default QuestionFAQ;
